import React from 'react';
import { ShieldCheck, Shield, UserCheck, GraduationCap } from 'lucide-react';
import { trustSignals } from '../../data/mock';

const iconMap = {
  1: ShieldCheck,
  2: Shield,
  3: UserCheck,
  4: GraduationCap,
};

const TrustSignals = () => {
  return (
    <section className="bg-[#121212] py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustSignals.map((signal) => {
            const Icon = iconMap[signal.id];
            return (
              <div
                key={signal.id}
                className="group p-6 border border-white/10 hover:border-[#00FFD1]/30 transition-all duration-400"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-[#00FFD1]/30 mb-4 group-hover:bg-[#00FFD1]/10 transition-all duration-400">
                  <Icon className="w-6 h-6 text-[#00FFD1]" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  {signal.title}
                </h3>
                <p className="text-white/60 text-base leading-relaxed">
                  {signal.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
